export function triggerLoadBuildAction(trigger){
    return async function(dispatch){
        const action = { type : 'TRIGGER_LOADBUILD', payload : trigger}
        dispatch(action);
    }
}

